import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import TabWallet from './slots/TabWallet';
import Header from './slots/Header';
import colors from 'theme/colors';
import Navbar from 'components/commons/Navbar';
import ticketsApi from 'api/requests/tickets';
import OrdersList from './slots/OrdersList';
import WalletDetail from './detail/WalletDetail';
import { useCollapse } from 'context/general/Collapse';
import breakpoints from 'theme/breakpoints';
import { useBackButtonCollapse } from 'context/general/BackButtonCollapse';
import DashHeader from 'modules/dashboard/_common/DashHeader';
import DashHeaderActions from 'modules/dashboard/_common/DashHeaderActions';

export default function MainWallet({ home }) {
    const [selectedTab, setSelectTab] = useState('active');
    const [isLoading, setIsLoading] = useState(true);
    const [finish, setFinish] = useState([]);
    const [active, setActive] = useState([]);
    const [selectedDetail, setSelectDetail] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const { collapse, setCollapse } = useCollapse();
    const { backButtonCollapse, setBackButtonCollapse } = useBackButtonCollapse();

    useEffect(() => {
        setBackButtonCollapse({
            ...backButtonCollapse,
            from: 'wallet-detail',
            data: selectedTab,
        });

        if (selectedDetail) {
            setCollapse({
                ...collapse,
                withHideCity: false,
                componentToRender: () => (
                    <WalletDetail
                        withBackButton
                        home
                        onBack={() => back()}
                        data={selectedDetail}
                    />
                )
            });
        }
    }, [selectedDetail]);

    const adaptEstablishmentToCard = (establishment) => {
        establishment.images = [
            establishment?.profileImage?.path ||
            establishment?.backgroundImage?.path
        ];
        establishment.path = establishment.images[0];
        return establishment;
    };

    const getTickets = async () => {
        try {
            const { data } = await ticketsApi.get();
            const currentDate = new Date();
            const finishedEvents = [];
            const activeEvents = [];

            data?.events?.forEach(event => {
                let eventDatePassed = false;

                event.dates.forEach(dateItem => {
                    const eventEndDate = new Date(`${dateItem.date}T${dateItem.end}`);
                    eventDatePassed = eventEndDate < currentDate;
                });

                if (eventDatePassed) {
                    finishedEvents.push(event);
                } else {
                    activeEvents.push(event);
                }
            });

            data?.establishments.forEach(establishment => {
                const hasUnusedTicket = establishment.tickets.some(ticket => !ticket.used_at);
                const adaptedEstablishment = adaptEstablishmentToCard(establishment);

                if (hasUnusedTicket) {
                    activeEvents.push(adaptedEstablishment);
                } else {
                    finishedEvents.push(adaptedEstablishment);
                }
            });

            setFinish(finishedEvents);
            setActive(activeEvents);
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getTickets();
    }, []);

    return (
        <Container>
            <DashHeader userView={true} />
            <DashHeaderActions />

            {!selectedDetail ? (
                <ContentArea>
                    <CenteredWrapper>
                        <Header
                            title={'Ingressos'}
                            subtitle={'Gerencie seus ingressos e pedidos'}
                        />

                        <TabWallet
                            toogleTab={setSelectTab}
                            selectedTab={selectedTab}
                            searchTerm={searchTerm}
                            onSearch={setSearchTerm}
                        />

                        {selectedTab === 'active' && (
                            <OrdersList
                                home={home}
                                data={active}
                                isLoading={isLoading}
                                renderDetail={setSelectDetail}
                                searchTerm={searchTerm}
                            />
                        )}

                        {selectedTab === 'finish' && (
                            <OrdersList
                                data={finish}
                                isLoading={isLoading}
                                expired={true}
                                home={home}
                                renderDetail={setSelectDetail}
                                searchTerm={searchTerm}
                            />
                        )}
                    </CenteredWrapper>

                    {!home && <Navbar />}
                </ContentArea>
            ) : (
                <DetailArea>
                    <WalletDetail
                        withBackButton
                        home
                        onBack={() => setSelectDetail(false)}
                        data={selectedDetail}
                    />
                </DetailArea>
            )}
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
    background: ${colors.neutralBackground};
    overflow: auto;
`;

const ContentArea = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 100px;
    padding-bottom: 100px;
`;

const CenteredWrapper = styled.div`
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
    padding: 0 20px;

    @media screen and (min-width: ${breakpoints.md}) {
        padding: 0 40px;
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        padding: 0 48px;
    }
`;

const DetailArea = styled.div`
    background: ${colors.neutralBackground};
    padding-bottom: 10px;
    overflow: auto;
`;
